import { ADA_METADATA, IPoolData } from "@sundaeswap/core";
import { PoolBrambleFragmentFragment, Version } from "../src/gql/generated/bramble.sdk";

export const MOCK_V3_RBERRY_POOL: IPoolData = {
  assetA: ADA_METADATA,
  assetB: {
    assetId: "99b071ce8580d6a3a11b4902145adb8bfd0d2a03935af8cf66403e15.524245525259",
    decimals: 0,
  },
  assetLP: {
    assetId:
      "633a136877ed6ad0ab33e69a22611319673474c8bd0a79a4c76d9289.000de1408325cc036806d513016fa259750194ba71b7748f3a23566e68fbe4d6",
    decimals: 0,
  },
  currentFee: 0.005,
  ident: "8325cc036806d513016fa259750194ba71b7748f3a23566e68fbe4d6",
  liquidity: {
    aReserve: 1_002_000_000n,
    bReserve: 1_000_000_000n,
    lpTotal: 0n,
  },
  version: "V3",
};

export const MOCK_V3_TINDY_POOL: IPoolData = {
  assetA: ADA_METADATA,
  assetB: {
    assetId: "fa3eff2047fdf9293c5feef4dc85ce58097ea1c6da4845a351535183.74494e4459",
    decimals: 0,
  },
  assetLP: {
    assetId:
      "633a136877ed6ad0ab33e69a22611319673474c8bd0a79a4c76d9289.0014df10a933477ea168013e2b5af4a9e029e36d26738eb6dfe382e1f3eab3e2",
    decimals: 0,
  },
  currentFee: 0.05,
  liquidity: {
    aReserve: 1018800000n,
    bReserve: 992067448n,
    lpTotal: 1005344874n,
  },
  ident: "1750b21414d4198763ee4d442f5c03a295a13a6028def9be4a785463",
  version: "V3",
};

export const MOCK_BRAMBLE_POOL: PoolBrambleFragmentFragment = {
  id: "08",
  assetA: {
    id: "ada.lovelace",
    policyId: "ada",
    description: "",
    dateListed: {
      format: "0001-01-01T00:00:00Z",
    },
    decimals: 6,
    ticker: "ADA",
    name: "lovelace",
    logo: "",
    assetName: "lovelace",
    metadata: [{ __typename: "CardanoTokenRegistry" }],
  },
  assetB: {
    id: "9a9693a9a37912a5097918f97918d15240c92ab729a0b7c4aa144d77.53554e444145",
    policyId: "9a9693a9a37912a5097918f97918d15240c92ab729a0b7c4aa144d77",
    description:
      "SundaeSwap is a decentralized exchange and liquidity provision protocol. SundaeSwap DAO Token allows holders to participate in SundaeSwap governance and additional features introduced by the DAO.",
    dateListed: {
      format: "2022-01-17T05:29:53Z",
    },
    decimals: 6,
    ticker: "SUNDAE",
    name: "SUNDAE",
    logo: "logos/983/9830390119461449821.png",
    assetName: "SUNDAE",
    metadata: [{ __typename: "CardanoTokenRegistry" }],
  },
  assetLP: {
    id: "0029cb7c88c7567b63d1a512c0ed626aa169688ec980730c0473b913.6c702008",
    policyId: "0029cb7c88c7567b63d1a512c0ed626aa169688ec980730c0473b913",
    description: null,
    dateListed: null,
    decimals: 0,
    ticker: null,
    name: "lp \b",
    logo: null,
    assetName: "lp \b",
    metadata: [],
  },
  feesFinalized: {
    slot: 0,
  },
  marketOpen: {
    slot: 0,
  },
  openingFee: [30, 10000],
  finalFee: [30, 10000],
  current: {
    quantityA: {
      quantity: "2882390419671",
    },
    quantityB: {
      quantity: "163730332905771",
    },
    quantityLP: {
      quantity: "21004819915208",
    },
    tvl: {
      quantity: "6023796708890",
    },
  },
  version: Version.V1,
};
